import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import Breadcrumb from '@/components/base/Breadcrumb';

const featureCards = [
  {
    icon: 'ri-flashlight-line',
    title: '一手爆料',
    desc: '全网最快速度追踪娱乐圈、直播圈、网红圈最新热点事件',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '多方核实信息来源，坚持真实爆料，拒绝无底线造谣',
  },
  {
    icon: 'ri-group-line',
    title: '吃瓜社区',
    desc: '汇聚百万吃瓜爱好者，评论区讨论热烈，吃瓜氛围一流',
  },
];

const testimonials = [
  {
    title: '行业标杆级的吃瓜平台',
    body: '作为一个做了十年娱乐媒体的老编辑，我可以负责任地说，黑料吃瓜在线是目前国内最专业的吃瓜资讯平台之一。内容质量、更新速度和用户口碑都处于行业领先水平。',
    author: '前某娱乐周刊主编',
    role: '媒体合作伙伴',
    stars: 5,
  },
  {
    title: '品牌口碑值得信赖',
    body: '我们品牌在选择合作媒体时非常谨慎。黑料吃瓜在线凭借专业的内容、良好的用户口碑和强大的传播力，成为了我们长期信赖的合作伙伴。',
    author: '某互联网品牌市场总监',
    role: '品牌合作伙伴',
    stars: 5,
  },
  {
    title: '真正懂吃瓜的平台',
    body: '市面上做娱乐资讯的平台很多，但真正懂吃瓜用户心理的没几个。黑料吃瓜在线从产品设计到内容策划，每一个细节都在为吃瓜群众考虑。',
    author: '知名互联网产品经理',
    role: '行业观察者',
    stars: 5,
  },
];

export default function AboutPage() {
  return (
    <>
      <JsonLd data={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Organization",
            "name": "黑料吃瓜在线",
            "url": "http://yusuwangluo.cn/",
            "description": "黑料吃瓜在线是国内领先的娱乐八卦资讯聚合平台，致力于为吃瓜爱好者提供最新最全的爆料内容。",
            "email": "hello@yusuwangluo.cn",
            "telephone": "400-888-6666",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "建国路88号SOHO现代城A座1208室",
              "addressLocality": "北京",
              "addressRegion": "朝阳区",
              "addressCountry": "CN"
            }
          },
          {
            "@type": "WebPage",
            "name": "关于我们 - 黑料吃瓜在线",
            "url": "http://yusuwangluo.cn/about",
            "description": "了解黑料吃瓜在线的品牌故事、核心特色和联系方式。",
            "isPartOf": { "@type": "WebSite", "name": "黑料吃瓜在线", "url": "http://yusuwangluo.cn/" }
          },
          {
            "@type": "FAQPage",
            "mainEntity": [
              { "@type": "Question", "name": "黑料吃瓜在线是什么平台？", "acceptedAnswer": { "@type": "Answer", "text": "黑料吃瓜在线是国内领先的娱乐八卦资讯聚合平台，覆盖娱乐圈黑料、主播塌房、网红八卦和社会热点四大核心频道。" } },
              { "@type": "Question", "name": "黑料吃瓜在线有哪些内容栏目？", "acceptedAnswer": { "@type": "Answer", "text": "平台设有娱乐圈黑料、主播塌房、网红八卦、社会热点四大频道，以及51黑料吃瓜在线观看、黑料吃瓜在线视频等核心栏目。" } },
              { "@type": "Question", "name": "如何联系黑料吃瓜在线？", "acceptedAnswer": { "@type": "Answer", "text": "hello@yusuwangluo.cn，客服热线为400-888-6666。" } }
            ]
          }
        ]
      }} />
      <Navbar />
      <main>
        <section className="pt-24 md:pt-28 pb-16 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

            <div className="flex flex-col lg:flex-row gap-12 md:gap-16 mt-6">
              <div className="lg:w-[40%]">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 border border-secondary-200/60 mb-6">
                  关于品牌
                </span>
                <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3">
                  黑料吃瓜在线
                </h1>
                <p className="font-heading text-3xl md:text-5xl text-secondary-400 mb-8">
                  你的每日吃瓜伴侣
                </p>

                <div className="space-y-5 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    黑料吃瓜在线成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为广大吃瓜爱好者提供最新、最全、最真实的娱乐圈黑料、主播网红塌房现场和热门网络爆料事件。
                  </p>
                  <p>
                    平台覆盖<strong>四大核心频道</strong>——娱乐圈黑料、主播塌房、网红八卦和社会热点，每日更新数十条高质量爆料内容，满足不同吃瓜群体的信息需求。
                  </p>
                  <p>
                    我们坚持<strong>"真实爆料、拒绝造谣"</strong>的运营理念，所有内容均经过编辑团队严格审核，确保信息来源可靠、报道角度客观。同时，我们倡导文明吃瓜，鼓励用户在评论区进行理性讨论。
                  </p>
                  <p>
                    截至目前，黑料吃瓜在线已累计发布超过5000篇原创爆料内容，服务超过200万吃瓜用户，成为中文互联网最具影响力的吃瓜资讯平台之一。
                  </p>
                </div>

                <Link
                  to="/"
                  className="mt-8 inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  立即开始吃瓜
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="lg:w-[55%]">
                <div className="flex items-end justify-end gap-4 mb-8">
                  <div className="text-right">
                    <div className="text-4xl md:text-5xl font-bold text-foreground-950">5000+</div>
                    <div className="text-xs text-secondary-500 mt-1">累计爆料文章</div>
                  </div>
                  <div className="text-right">
                    <div className="text-4xl md:text-5xl font-bold text-foreground-950">200万+</div>
                    <div className="text-xs text-secondary-500 mt-1">忠实吃瓜用户</div>
                  </div>
                </div>

                <div className="relative flex justify-end">
                  <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-xl overflow-hidden z-20 -mr-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Creative%20team%20working%20in%20a%20modern%20office%20environment%2C%20casual%20atmosphere%2C%20warm%20natural%20lighting%2C%20collaborative%20workspace%20with%20laptops%2C%20editorial%20style%20photography%2C%20clean%20composition%2C%20friendly%20professional%20mood&width=600&height=600&seq=about-team-photo&orientation=squarish"
                      alt="黑料吃瓜在线团队"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="relative w-36 h-48 md:w-44 md:h-60 rounded-xl overflow-hidden z-10">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20warm%20lighting%2C%20creative%20workspace%20design%2C%20comfortable%20lounge%20area%2C%20plants%20and%20art%20on%20walls%2C%20editorial%20interior%20photography%2C%20clean%20composition%2C%20inviting%20professional%20atmosphere&width=600&height=800&seq=about-office-photo&orientation=portrait"
                      alt="办公环境"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                三大栏目特色
              </h2>
              <p className="text-sm text-secondary-500 max-w-md mx-auto">
                为什么选择黑料吃瓜在线
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                { ...featureCards[0], img: 'https://readdy.ai/api/search-image?query=Abstract%20gradient%20background%20with%20soft%20geometric%20shapes%20in%20warm%20earthy%20tones%2C%20minimalist%20design%2C%20luxurious%20texture%2C%20dark%20background%20with%20warm%20golden%20accents%2C%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=about-feature-1&orientation=landscape' },
                { ...featureCards[1], img: 'https://readdy.ai/api/search-image?query=Abstract%20gradient%20background%20with%20fluid%20organic%20shapes%20in%20amber%20and%20terracotta%20tones%2C%20minimalist%20elegant%20design%2C%20soft%20velvet%20texture%2C%20dark%20background%20with%20warm%20highlights%2C%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=about-feature-2&orientation=landscape' },
                { ...featureCards[2], img: 'https://readdy.ai/api/search-image?query=Abstract%20gradient%20background%20with%20layered%20circles%20in%20warm%20crimson%20and%20gold%20tones%2C%20minimalist%20luxurious%20design%2C%20smooth%20texture%2C%20dark%20background%20with%20warm%20accents%2C%20editorial%20style%2C%20clean%20composition&width=800&height=600&seq=about-feature-3&orientation=landscape' },
              ].map((feature) => (
                <div
                  key={feature.title}
                  className="relative aspect-[4/3] rounded-xl overflow-hidden group cursor-default"
                >
                  <img
                    src={feature.img}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6">
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mb-4">
                      <i className={`${feature.icon} text-4xl md:text-5xl`}></i>
                    </div>
                    <h3 className="font-heading text-xl md:text-2xl font-bold mb-2">{feature.title}</h3>
                    <p className="text-xs text-white/70 max-w-[220px] text-center leading-relaxed">{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 px-4 md:px-6 bg-accent-50/50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-16">
              <div className="flex items-center justify-center gap-2 mb-4">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">品牌口碑</span>
              </div>
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                合作伙伴评价
              </h2>
              <p className="text-sm text-secondary-500 max-w-md mx-auto">
                来自行业伙伴的真实反馈
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i key={i} className={`text-sm ${i < t.stars ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-secondary-300'}`}></i>
                    ))}
                  </div>
                  <h4 className="text-sm font-bold text-foreground-950 mb-2">{t.title}</h4>
                  <p className="text-xs text-secondary-600 leading-relaxed mb-4">{t.body}</p>
                  <div>
                    <p className="text-xs font-semibold text-foreground-950">{t.author}</p>
                    <p className="text-xs text-secondary-500">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-18 px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-accent-100 rounded-full">
                  <i className="ri-mail-line text-xl text-accent-600"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">商务合作</h3>
                <p className="text-sm text-secondary-500">hello@yusuwangluo.cn</p>
              </div>
              <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 bg-primary-100 rounded-full">
                  <i className="ri-phone-line text-xl text-primary-600"></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">客服热线</h3>
                <p className="text-sm text-secondary-500">400-888-6666</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}